import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=0fbc3f3a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./Datenschutz.vue?vue&type=script&lang=js&"
export * from "./Datenschutz.vue?vue&type=script&lang=js&"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=0fbc3f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc3f3a",
  null
  
)

export default component.exports